import baguetteBox from 'baguettebox.js';

//popup
baguetteBox.run('.photo-gallery, .gallery-item');
